var LocalAPIOverrideStorageKey = 'LOCAL_API_OVERRIDE';
var getAPIUrl = function () {
    var _a;
    var pathname = window.location.pathname;
    switch (pathname) {
        case 'beta.turn2me.ie':
            return 'https://turn2me-api-htroeoozwa-ew.a.run.app';
        case 'pre-release.turn2me.ie':
            return 'https://turn2me-api-production-htroeoozwa-ew.a.run.app';
        case 'localhost':
            return (_a = localStorage.getItem(LocalAPIOverrideStorageKey)) !== null && _a !== void 0 ? _a : 'https://turn2me-v2-api.eu.ngrok.io';
        default: return 'https://turn2me-v2-api.eu.ngrok.io';
    }
};
export var API_URL = getAPIUrl().replace(/\/+$/, "") + "/api";
